import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { AIFC_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-afic-onboarding';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadAIFCOnboardingStateForTopNav = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(AIFC_ONBOARDING_STATE_KEYS)],
		},
	});
};
